import { modifiers } from "ui-tools"

import s from "./Card.module.scss"

type CardProps = {
  children: React.ReactNode
  borderRadius?: "small" | "medium" | "large"
  backgroundColor?: string
}
export const Card = ({
  children,
  borderRadius = "medium",
  backgroundColor,
}: CardProps) => {
  return (
    <div
      className={modifiers(s, "card", `border-radius-${borderRadius}`)}
      style={{ backgroundColor }}
    >
      {children}
    </div>
  )
}

Card.Content = ({ children }: { children: React.ReactNode }) => (
  <div className={s.card__content}>{children}</div>
)
